import React, { useState } from 'react';
import { format } from 'date-fns';
import propTypes from 'prop-types';
import gql from 'graphql-tag';
import { useMutation } from 'react-apollo';
import { FaReply, FaTimes } from 'react-icons/fa';
import { useParams } from 'react-router-dom';
import { makeAvatar } from '../../utils/app';
import CommentReplyForm from '../CommentReplyForm';
import CommentReplies from '../CommentReplies';
import RestrictedContainer from '../RestrictedContainer';

const addReplyGql = gql`
  mutation addReply($subjectId: ID!, $commentId: ID!, $text: String!, $condominiumId: ID!) {
    subjectAddCommentReply(subjectId: $subjectId, commentId: $commentId, condominiumId: $condominiumId, text: $text) {
      text
      user {
        _id
      }
    }
  }
`;

export default function CommentItem({ comment, refetchComments }) {
  const [isReplying, setReplying] = useState(false);
  const { subjectId, condominiumId } = useParams();
  const [addReplyFn] = useMutation(addReplyGql, {
    onCompleted: () => {
      refetchComments();
      setReplying(false);
    },
  });

  const submit = text =>
    addReplyFn({
      variables: {
        subjectId,
        condominiumId,
        commentId: comment._id,
        text,
      },
    });

  return (
    <div className="list-group-item comments">
      <div className="header">
        <div className="avatar-holder">
          <div className="avatar d-flex align-items-center justify-content-center">
            {comment.user ? makeAvatar(comment.user.name) : ''}
          </div>
        </div>
        <div className="infos">
          <span className="text-muted">{comment.createdAt && format(comment.createdAt, 'DD/MM/YYYY HH:mm')}</span>
          <b>{(comment.user && comment.user.name) || ''}</b>
          {comment.user && comment.user.condominiums[0] && comment.user.condominiums[0].unity && (
            <span className="text-muted">
              Unidade:
              {comment.user.condominiums[0].unity}
            </span>
          )}
        </div>
      </div>
      <p>{comment.text}</p>
      <CommentReplies replies={comment.replies || []} />
      {isReplying && <CommentReplyForm onSubmit={submit} />}

      <div className="d-flex align-items-center justify-content-end">
        <button onClick={() => setReplying(x => !x)} className="btn bt-sm" type="button">
          {isReplying && (
            <small className="text-danger">
              <FaTimes className="mr-1" />
              cancelar
            </small>
          )}
          <RestrictedContainer permission="comment">
            {!isReplying && comment._id && (
              <small className="text-prymary">
                <FaReply className="mr-1" />
                responder
              </small>
            )}
          </RestrictedContainer>
        </button>
      </div>
    </div>
  );
}

CommentItem.propTypes = {
  comment: propTypes.object.isRequired,
  refetchComments: propTypes.func.isRequired,
};
